import { TInputHiddenInstance } from 'widgets/forms/InputHidden';

/**
 * @param AjaxForm Base widget for extending
 * @returns BackInStock widget
 */
function BackInStockClassCreator(AjaxForm: import('widgets/forms/AjaxForm').TAjaxForm) {
    /**
     * @category widgets
     * @subcategory forms
     * @class BackInStock
     * @augments AjaxForm
     * @classdesc Represents BackInStock component with next features:
     * 1. Updates product id of the product available for back in stock
     *
     * @property {string} data-widget - Widget name `backInStock`
     * @example <caption>Example of BackInStock widget usage</caption>
     *  <form
     *    data-widget="backInStock"
     *    data-event-submit="handleSubmit"
     *    data-widget-event-submit="handleBackInStockFormSubmit"
     *    data-id="backInStock"
     *    data-forward-to-parent="hideContent"
     *    action="${URLUtils.url('BackInStock-Subscribe')}"
     *    method="POST"
     *    novalidate="novalidate"
     *  >
     *      ...
     *      <input
     *          type="hidden"
     *          data-widget="inputHidden"
     *          data-ref="field"
     *          data-id="backInStockProductId"
     *          value="${product.id}"
     *          name="${pdict.backInStockForm.productID.htmlName}"
     *      />
     *      ...
     *  /form>
     */
    class BackInStock extends AjaxForm {
        updateProductId(productId) {
            this.getById('backInStockProductId', (backInStockProductId: TInputHiddenInstance) => {
                backInStockProductId.setValue(productId);
            });
        }
    }

    return BackInStock;
}

export type TBackInStock = ReturnType<typeof BackInStockClassCreator>;

export type TBackInStockInstance = InstanceType<TBackInStock>;

export default BackInStockClassCreator;
